<div class="fluid-container">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-8 step-title">
            <h5 class="mb-0">Petitioner Details & Documents DEF</h5>
            <p class="mb-0">Upload supporting petitioner documents DEF</p>
        </div>
        
        <div class="col-md-4 editBtn headerSubPortion px-0"> 
            <ul>
              <li class="col-auto px-0 firstPortion"> 
                <gc-status-update [stepDetails]="stepDetails" type="EDIT"></gc-status-update>
              </li>
              <li class="col-auto pr-0 pl-2 secondPortion">
                <lib-maximize-dialog-library [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
            <i (click)="handleClose();" class="close-icon pi pi-times pull-right"></i>
              </li>
            </ul>
          </div>
    </div>
    <div class="row"> 
        <div class="col-md-12 p-0">
            <!-- <lib-assigning-task-library  [stepDetails]="stepDetails" (updateStatus)="updateStepStatus($event)">
            </lib-assigning-task-library> -->
            <lib-assigning-task-library [visaType]="inputData.visatype" [stepDetails]="stepDetails"
            (updateStatus)="updateStepStatus($event)" [isViewMode]="inputData['isViewMode']" [isCaseRequest]="inputData['isCaseRequest']">
            </lib-assigning-task-library>
        </div>
    </div>
    <p-divider></p-divider>
    <div class="main-body footer-adjust">
        <lib-in-care-of-name [inputData]="dynamicDialogConfig.data" [petitionId]="dynamicDialogConfig.data.i140CaseId" [disabledControls]="disabledControls"></lib-in-care-of-name>
        <div class="row col-md-12 pt-3 pb-3">
            <h5 class="sub-title">Petitioner Details</h5>
        </div>
        <div class="row pb-3">
            <div class="col">
                <label class="label-cls">Employer Name</label>
                <div class="readOnly-label">{{petitionerDetails?.companyName}}</div>
            </div>
        </div>
        <div class="row  pb-3">
            <div class="col-md-4">
                <label class="label-cls">Address Line 1</label>
                <div class="readOnly-label">{{petitionerDetails?.address[0]?.addressLine1}}</div>
            </div>
            <div class="col-md-4">
                <label class="label-cls">Address Line 2</label>
                <div class="readOnly-label">{{petitionerDetails?.address[0]?.addressLine2}}</div>
            </div>
            <div class="col-md-4">
                <label class="label-cls">Country</label>
                <div class="readOnly-label">{{petitionerDetails?.address[0]?.countryCode?.countryName}}</div>
            </div>
        </div>
        <div class="row pb-4">
            <div class="col-md-4">
                <label class="label-cls">State</label>
                <div class="readOnly-label" *ngIf="!petitionerDetails?.address[0]?.stateProvinceName === null">
                    {{petitionerDetails?.address[0]?.stateProvinceName}}</div>
                <div class="readOnly-label" *ngIf="petitionerDetails?.address[0]?.stateProvinceName === null">
                    {{petitionerDetails?.address[0]?.stateName}}</div>
            </div>
            <div class="col-md-4">
                <label class="label-cls">City</label>
                <div class="readOnly-label">{{petitionerDetails?.address[0]?.city}}</div>
            </div>
            <div class="col-md-4">
                <label class="label-cls">ZIP / Postal Code</label>
                <div class="readOnly-label">{{petitionerDetails?.address[0]?.postCode}}</div>
            </div>
        </div>
        <p-divider></p-divider>
        <div class="row col-md-12 p-0 pt-2 d-flex align-items-center">
            <div class="col-md-6">
                <h5 class="sub-title">Default documents from Company Profile</h5>
            </div>
            <div class="col-md-6 sync-btn">
                <button type="button" pButton label="SYNC" pTooltip="Sync From Company Profile"
                    class="p-button-outlined" (click)="syncPetitionerDocuments()" [disabled]="disabledControls"
                    class="p-button-text pull-right p-button-outlined"></button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 p-0 ">
                <i140-file-upload style="width: 100%;" [fileUploadConfigurations]="fileUploadConfigurations">
                </i140-file-upload>
            </div>
        </div>
        <div class="col-md-12 pb-4">
            <h5 class="sub-title">Default </h5>
        </div>
        <div class="col-md-12 p-0 ">
            <i140-file-upload style="width: 100%;" [fileUploadConfigurations]="fileUploadConfigurations1">
            </i140-file-upload>
        </div>
    </div>
    <p-divider></p-divider>
    <div class="row pt-3">
        <div class="col-md-6">
        </div>
        <div class="col-md-6">
            <gc-status-update [stepDetails]="stepDetails" [type]="typeOfButton" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></gc-status-update>
        </div>
    </div>
</div>